var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTailor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 18V50.5H38.75V27.375H31.875C30.4943 27.375 29.375 26.2557 29.375 24.875V18H13.75ZM10.0314 14.2814C10.8519 13.4609 11.9647 13 13.125 13H31.875C32.538 13 33.1739 13.2634 33.6428 13.7322L43.0178 23.1072C43.4866 23.5761 43.75 24.212 43.75 24.875V51.125C43.75 52.2853 43.2891 53.3981 42.4686 54.2186C41.6481 55.0391 40.5353 55.5 39.375 55.5H13.125C11.9647 55.5 10.8519 55.0391 10.0314 54.2186C9.21093 53.3981 8.75 52.2853 8.75 51.125V17.375C8.75 16.2147 9.21094 15.1019 10.0314 14.2814Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 10.5V15.5C21.25 16.8807 20.1307 18 18.75 18C17.3693 18 16.25 16.8807 16.25 15.5V9.875C16.25 8.71468 16.7109 7.60188 17.5314 6.78141C18.3519 5.96094 19.4647 5.5 20.625 5.5H39.375C40.038 5.5 40.6739 5.76339 41.1428 6.23223L50.5178 15.6072C50.9866 16.0761 51.25 16.712 51.25 17.375V43.625C51.25 44.7853 50.7891 45.8981 49.9686 46.7186C49.1481 47.5391 48.0353 48 46.875 48H41.25C39.8693 48 38.75 46.8807 38.75 45.5C38.75 44.1193 39.8693 43 41.25 43H46.25V18.4105L38.3395 10.5H21.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.125 36.125C18.125 34.7443 19.2443 33.625 20.625 33.625H31.875C33.2557 33.625 34.375 34.7443 34.375 36.125C34.375 37.5057 33.2557 38.625 31.875 38.625H20.625C19.2443 38.625 18.125 37.5057 18.125 36.125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.125 43.625C18.125 42.2443 19.2443 41.125 20.625 41.125H31.875C33.2557 41.125 34.375 42.2443 34.375 43.625C34.375 45.0057 33.2557 46.125 31.875 46.125H20.625C19.2443 46.125 18.125 45.0057 18.125 43.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailor);
export default __webpack_public_path__ + "static/media/tailor.4aab7b3985c8227a1a9a2ceaffa70b50.svg";
export { ForwardRef as ReactComponent };